import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getPublicConsultations } from '../../../actions/public_consultations/public_consultations';

import PublicConsultationsListingBody from './PublicConsultationsListingBody';
import {
  DEFAULT_ITEMS_LIMIT,
  MAX_ITEMS_LIMIT,
  MIN_ITEMS_LIMIT,
} from './schema';

const normalizeItemsLimit = (value) => {
  const parsedValue = Number.parseInt(value, 10);
  if (Number.isNaN(parsedValue)) return DEFAULT_ITEMS_LIMIT;
  return Math.min(MAX_ITEMS_LIMIT, Math.max(MIN_ITEMS_LIMIT, parsedValue));
};

const View = (props) => {
  const { data = {} } = props;
  const dispatch = useDispatch();
  const publicConsultationsState = useSelector(
    (state) => state.public_consultations,
  );

  const params = useMemo(
    () => ({
      limit: normalizeItemsLimit(data.itemsLimit),
      filtro_orgao: data.filterByOrganization ? 'yes' : 'no',
    }),
    [data.filterByOrganization, data.itemsLimit],
  );

  useEffect(() => {
    dispatch(getPublicConsultations({ params }));
  }, [dispatch, params]);

  return (
    <PublicConsultationsListingBody
      {...props}
      publicConsultations={publicConsultationsState}
    />
  );
};

export default View;
